<template>
  <div class="myAlumni">
    <div class="alumnusDiv">
      <template v-if="alumnus.length > 0">
        <template v-for="item in alumnus" class="alumni-card-box">
          <AlumniInfoCard :info="item" @go="gotoAlumnusDetail"></AlumniInfoCard>
        </template>
      </template>
      <div class="myNoDonation" v-else>
        <div class="noDonationDiv">
          <img
            src="../../assets/image/btn_nojuanzeng_nor.png"
            alt="图片"
            class="noDonation"
          />
        </div>
        <div class="tip">您还没有好友呦~</div>
      </div>
    </div>
  </div>
</template>
<script>
import AlumniInfoCard from "../alumniResources/components/AlumniInfoCard/myAluminAssembly.vue";
export default {
  components: {
    AlumniInfoCard,
  },
  data() {
    return {
      sameYear: "",
      userId: window.localStorage.getItem("user_id"),
      // userId:'43995354',
      myCity: "",
      alumnus: [],
    };
  },
  created() {
    this.displayFriends();
    // this.displaySameYear();
    this.getMyCity();
  },
  methods: {
    async displayFriends() {
      const result = await this.$http.get("/myFriend/getFriends", {
        params: {
          id: this.userId,
          page: 1,
          size: 200,
        },
      });
      this.alumnus = result.data;
    },

    async gotoAlumnusDetail(userId) {
      // if (!(await this.toRealName())) {
      //   return;
      // }
      return this.$router.push({
        path: "/alumniDetailNew",
        query: {
          alumniId: userId,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.myAlumni {
  position: relative;
}

.alumnusDiv {
  padding-top: 5px;
  overflow-x: scroll;
  overflow-y: hidden;
}

.alumnusDiv::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}

.navDiv {
  margin-top: 10px;
  display: flex;
  justify-content: center;

  .nav {
    width: 60%;
    display: flex;
    justify-content: space-between;

    .sameYear {
      font-size: 1.2rem;
      font-weight: bold;
      color: #333333;
    }

    .sameCollage,
    .friends {
      font-weight: bold;
      color: #999999;
    }
  }
}

.noFriend {
  display: flex;
  flex-direction: column;
  align-items: center;

  .noFriendImg {
    margin-top: 20%;
    width: 60%;
  }

  .noFriendTips {
    margin-top: 50px;
    font-size: 1.2rem;
    font-weight: 400;
    color: #666666;
  }
}

.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

.clearfix {
  *zoom: 1;
}

.alumniDiv {
  margin-top: 10px;
  border-radius: 0px 0px 15px 15px;
}

.alumniCard {
  position: relative;
  left: 4%;
  width: 92%;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  border-radius: 15px;
  margin-bottom: 20px;
}

.alumniPhotoDiv {
  width: 25%;
  height: 23vw;
  float: left;
  padding: 10px;
  max-height: 200px;
  max-width: 200px;
}

.alumniPhoto {
  width: 100%;
  height: 100%;
  border-radius: 999px;
}

.sexDiv {
  position: absolute;
  left: 21%;
  top: 5%;
}

.sex {
  width: 22px;
  height: 22px;
}

.adress {
  text-align: center;
  font-size: 1em;
  color: #00706E;
  font-weight: 600;
}

.alumniData {
  float: left;
  width: 68%;
  padding-bottom: 10px;
}

.alumniName {
  padding-top: 10px;
  font-size: 1.2em;
  padding-bottom: 10px;
  color: #333333;
  font-weight: 600;
}

.alumniSchoolAndDissertation {
  padding: 2.5px 0px 2.5px 0px;
  color: #666666;
}

.alumniIndustry {
  padding: 2.5px 0px 2.5px 0px;
  color: #666666;
}

.alumniCompany {
  padding: 2.5px 0px 2.5px 0px;
  color: #666666;
}

.alumniResources {
  margin: 2.5px 0px 2.5px 0px;
  color: #666666;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.myNoDonation {
  height: 100vh;
}

.noDonationDiv {
  position: absolute;
  left: 50%;
  top: 10%;
  transform: translateX(-50%);
}

.noDonation {
  width: 100%;
}

.tip {
  position: absolute;
  left: 50%;
  top: 35%;
  transform: translateX(-50%);
  color: #666666;
  font-size: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/mine/MyAlumni.vue